import * as go from 'gojs';

export class ExtendedNode extends go.Node {
  private _forceNewPosition = false;

  /**
   * Gets or sets whether this part should be positioned during a layout.
   * The initial and normal value is false.
   *
   * This differs from #isLayoutPositioned in that setting this value to `true`
   * allows this part to still be considered in determining the layout of other
   * parts, but this part itself will not be not repositioned.
   */
  get forceNewPosition() {
    return this._forceNewPosition;
  }

  set forceNewPosition(value: boolean) {
    this._forceNewPosition = value;
  }

  cloneProtected(copy: this) {
    super.cloneProtected(copy);
    // eslint-disable-next-line no-param-reassign
    copy.forceNewPosition = this.forceNewPosition;
  }
}
